import { Box } from "@mui/material";

import { Images, ShortDescription, TitleRating } from "./components";
import Section from "@/components/Section";
import useResponsive from "@/hooks/useResponsive";

interface IProps {
  product: IProductDetails;
  scrollToDetails: () => void;
}

const ProductCardNew: React.FC<IProps> = ({ product, scrollToDetails }) => {
  const isMobile = useResponsive("down", "sm");
  const { id, name, productImages } = product;

  return (
    <Section pt={{ xs: 0, md: 2, lg: 8 }} pb={{ xs: 3.5, md: 8, lg: 15 }}>
      {isMobile && <TitleRating title={name} />}
      <Box
        display={{ xs: "flex", md: "flex", lg: "flex", xl: "flex" }}
        gap={{ md: 4, lg: 6, xl: 8.5 }}
        flexDirection={{ xs: "column", sm: "row", md: "row" }}
      >
        <Images id={id} title={name} images={productImages} />
        <ShortDescription product={product} scrollToDetails={scrollToDetails} />
      </Box>
    </Section>
  );
};

export default ProductCardNew;
